import { render, staticRenderFns } from "./observa4Pellet.vue?vue&type=template&id=c3fca678&scoped=true"
import script from "./observa4Pellet.vue?vue&type=script&lang=js"
export * from "./observa4Pellet.vue?vue&type=script&lang=js"
import style0 from "./observa4Pellet.vue?vue&type=style&index=0&id=c3fca678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3fca678",
  null
  
)

export default component.exports